const toCase = (str: string) =>
  str
    .toLowerCase()
    .split(' ')
    .map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

export default toCase;
